import React from 'react'
import { connect } from 'react-redux'
import { Row } from 'reactstrap'
import useFetchingConfiguredCompanies from './useFetchingConfiguredCompanies'
import CompaniesTable from './CompaniesTable'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const Companies = (props) => {
  useFetchingConfiguredCompanies()

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <Row>
          <PageHeading>Companies</PageHeading>
        </Row>
        <CompaniesTable companies={props.setupCompanyList} />
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loading,
  setupCompanyList: state.company.setupCompanyList,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Companies)
